<template>

    <div class="project-box">
        <!--        <b-row>-->
        <!--            <b-col cols="6">-->
        <!--                <div class="d-flex justify-content-end">-->
        <!--                    <router-link :to="{name:projectPageName,params:{projectID:project.id}}">-->

        <!--                        <img :src="thumbnailURL" alt="" class="project-thumbnail">-->
        <!--                    </router-link>-->
        <!--                </div>-->
        <!--            </b-col>-->
        <!--            <b-col cols="6">-->
        <!--                <div class="d-flex">-->
        <!--                    <div class="project-info">-->
        <!--                        <h2>-->
        <!--                            {{project.title}}-->
        <!--                        </h2>-->
        <!--                        <div class="property-value-pair" v-for="propertyValuePair in project.propertyvaluepair">{{propertyValuePair.property}}: {{propertyValuePair.value}}</div>-->
        <!--                    </div>-->

        <!--                </div>-->
        <!--            </b-col>-->
        <!--            &lt;!&ndash;    <div class="project-box d-flex justify-content-start">&ndash;&gt;-->
        <!--            &lt;!&ndash;        &lt;!&ndash;            <div class="project-thumbnail" :style="{backgroundImage:'url('+thumbnailURL+')'}">&ndash;&gt;&ndash;&gt;-->
        <!--            &lt;!&ndash;        &lt;!&ndash;                &ndash;&gt;&ndash;&gt;-->
        <!--            &lt;!&ndash;        &lt;!&ndash;            </div>&ndash;&gt;&ndash;&gt;-->
        <!--            &lt;!&ndash;    </div>&ndash;&gt;-->
        <!--        </b-row>-->


        <div class="d-flex p-2">
            <router-link :to="{name:projectPageName,params:{projectID:project.id}}" style="width: 100%;">

              <div v-if="isShowcase">

                <img v-if="projectType==='photo'" :src="showcaseThumbnailURL" alt="" class="project-thumbnail">
                <video v-if="projectType==='video'" :src="showcaseThumbnailURL" alt="" class="project-thumbnail" muted autoplay loop playsinline></video>

              </div>
              <div v-else>
                <img v-if="projectType==='photo'" :src="thumbnailURL" alt="" class="project-thumbnail">
                <video v-if="projectType==='video'" :src="thumbnailURL" alt="" class="project-thumbnail" muted autoplay loop playsinline></video>

              </div>
            </router-link>
        </div>

        <div class="d-flex">
            <div class="project-info">
              <router-link :to="{name:projectPageName,params:{projectID:project.id}}" style="width: 100%;">

              <h2 class="project-box-title">
                    {{project.title}}
                </h2>
              </router-link>

                <VueShowdown class="project-listing-info" v-if="project.listinginfo" :markdown="project.listinginfo"></VueShowdown>
                <div class="property-value-pair" v-for="propertyValuePair in project.propertyvaluepair">{{propertyValuePair.property}}: {{propertyValuePair.value}}</div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "ProjectBox",
        props: ['project', 'projectType', 'isShowcase'],
        computed: {
            projectPageName: function () {
                if (this.projectType === "photo") {
                    return "PhotoProjectPage"
                } else if (this.projectType === "video") {
                    return "VideoProjectPage"
                }
            },
            thumbnailURL: function () {
                if (this.project.thumbnail) {
                    return process.env.VUE_APP_API_URL + this.project.thumbnail.url
                } else {
                    return null
                }
            },
            showcaseThumbnailURL: function () {
                if (this.project.showcasethumbnail) {
                    return process.env.VUE_APP_API_URL + this.project.showcasethumbnail.url
                } else {
                    return null
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .project-box {
        margin-bottom: 2em;
    }
    .project-box-title{
        font-weight: 600;
    }

    .project-thumbnail {
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        width: 100%;
        object-fit: contain;
        object-position: center;
    }

    .project-info {

    }

    .property-value-pair {
        font-size: .8em;
    }

    .project-listing-info {
        font-size: .8em;
    }
</style>